import React from 'react'

// ─────────────────────────────────────────────────────────────────────────────
// Loader , the 3-bar DKG logo loader.
//
//   <Loader size={64} />
//   <Loader size={48} label="Wird geladen…" />
//
// Self-contained: keyframes are emitted inline so the component works anywhere
// (modal portals, isolated pages, etc.) without needing a parent CSS scope.
// React + the browser will de-duplicate the <style> tag at render time.
//
// Colors match the legacy DKG brand orange (#f29400 / #f19400), kept
// intentionally distinct from the v2 form-orange (#e85d1f) so the loader
// reads as a brand element, not a form action.
// ─────────────────────────────────────────────────────────────────────────────

const STYLES = `
@keyframes ds-loader-up   { 20%,99%{transform:translateY(0)} 31%,90%{transform:translateY(-13px)} }
@keyframes ds-loader-down { 20%,99%{transform:translateY(0)} 31%,90%{transform:translateY(13px)}  }
@keyframes ds-loader-spin { 0%,21%{transform:rotate(0deg)} 22%{transform:rotate(0deg)} 98%{transform:rotate(720deg)} 100%{transform:rotate(720deg)} }
.ds-loader .ds-loader-bar     { transform-origin: center; transform-box: fill-box; }
.ds-loader .ds-loader-bar rect { fill: #f29400; filter: drop-shadow(0 2px 6px rgba(242,148,0,.28)); }
.ds-loader .ds-loader-bar--bot rect { fill: #f19400; }
.ds-loader .ds-loader-bar--top { animation: ds-loader-up   2.4s cubic-bezier(.45,.05,.35,1) infinite; }
.ds-loader .ds-loader-bar--mid { animation: ds-loader-spin 2.4s linear infinite; }
.ds-loader .ds-loader-bar--bot { animation: ds-loader-down 2.4s cubic-bezier(.45,.05,.35,1) infinite; }
@media (prefers-reduced-motion: reduce) {
  .ds-loader .ds-loader-bar { animation: none !important; }
}
`

export const Loader = React.memo(function Loader({
  size = 64,
  label = 'Wird geladen',
  className = '',
}) {
  return (
    <span
      className={'ds-loader inline-flex ' + className}
      role="status"
      aria-label={label}
      style={{ overflow: 'visible' }}
    >
      <style>{STYLES}</style>
      <svg
        width={size}
        height={size}
        viewBox="-2 -16 80 81"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
        aria-hidden="true"
        focusable="false"
      >
        <g className="ds-loader-bar ds-loader-bar--top">
          <rect x="-0.5" y="-0.5" width="52" height="10" rx="4"/>
        </g>
        <g className="ds-loader-bar ds-loader-bar--mid">
          <rect x="24.5" y="17.5" width="51" height="10" rx="4"/>
        </g>
        <g className="ds-loader-bar ds-loader-bar--bot">
          <rect x="14.5" y="34.5" width="50" height="10" rx="4"/>
        </g>
      </svg>
    </span>
  )
})
